import React from "react";
import Button from "@mui/material/Button";

export default function SkipToContentLink() {
  return (
    <Button
      href="#main-content"
      variant="outlined"
      color="secondary"
      sx={(theme) => ({
        position: "absolute",
        left: -9999,
        top: theme.spacing(2),
        transform: "translateX(-50%)",
        "&:focus": {
          left: "50%",
        },
      })}
    >
      Skip to main content
    </Button>
  );
}
